/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';
import { useTheme } from '../theme';
const DragHandle = (props) => {
    const theme = useTheme();
    return (jsx("div", Object.assign({ draggable: true, contentEditable: false }, props, { css: {
            position: 'absolute',
            width: '12px',
            height: 'auto',
            top: 0,
            bottom: 0,
            left: 0,
            cursor: 'grab',
            '&:active': {
                cursor: 'grabbing',
            },
            '&::before': {
                backgroundColor: theme.colors.dragHandle.edge,
                position: 'absolute',
                top: 0,
                left: 0,
                width: '2px',
                height: '100%',
                content: '" "',
            },
            stroke: theme.colors.dragHandle.icon,
            display: 'inline-flex',
            alignItems: 'center',
        } }),
        jsx("svg", { viewBox: "0 0 24 24", fill: "none", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", height: "100%", width: "100%" },
            jsx("circle", { cx: "8", cy: "12", r: "1" }),
            jsx("circle", { cx: "8", cy: "5", r: "1" }),
            jsx("circle", { cx: "8", cy: "19", r: "1" }),
            jsx("circle", { cx: "16", cy: "12", r: "1" }),
            jsx("circle", { cx: "16", cy: "5", r: "1" }),
            jsx("circle", { cx: "16", cy: "19", r: "1" }))));
};
export default React.memo(DragHandle);
//# sourceMappingURL=DragHandle.js.map